<template>
    <BApp>
        <GlobalErrorsInit />
        <VersionChecker>
            <RouterView />
        </VersionChecker>
        <HelpDrawer />
    </BApp>
</template>

<script setup lang="ts">
import { useOrganisationStore } from '@/stores/organisationStore';
import { useNotificationStore } from '@/stores/notificationStore';
import { useMenuBadgesFromCounts } from '@/queries/counts';
import GlobalErrorsInit from '@/components/GlobalErrorsInit.vue';
import VersionChecker from '@/components/VersionChecker.vue';
import HelpDrawer from '@/components/help/HelpDrawer.vue';
import { watch } from 'vue';
import { echo } from '@laravel/echo-vue';
import type { OrganisationNotificationBroadcast } from '@/queries/notifications';
const organisationStore = useOrganisationStore();
const notificationStore = useNotificationStore();

useMenuBadgesFromCounts();

/*
 * Keyed by public id rather than the integer key. The browser names the channel
 * it subscribes to, and API resources do not expose primary keys -- watching one
 * would stop firing the moment the organisation payload stopped carrying it.
 */
watch(
    () => (organisationStore.hasActiveOrganisation ? organisationStore.current_organisation.public_id : null),
    (publicId, previousPublicId) => {
        const echoInstance = echo();

        if (previousPublicId) {
            echoInstance.leave(`organisation.${previousPublicId}`);
        }

        if (publicId) {
            notificationStore.fetchOrganisationNotifications(organisationStore.current_organisation);

            echoInstance
                .private(`organisation.${publicId}`)
                .listen('OrganisationNotificationCreated', (payload: OrganisationNotificationBroadcast) => {
                    notificationStore.applyBroadcastNotification(payload);

                    if (payload.notification === null) {
                        notificationStore.fetchOrganisationNotifications(organisationStore.current_organisation);
                    }
                });
        }
    },
    { immediate: true },
);
</script>

<style lang="scss"></style>
